import type { Brand } from '../../../shared/api/brands.api'

// Нормализация строки бренда: нижний регистр + тримминг, удаление пунктуации вокруг
function normalize(v: string): string {
  return v.trim().toLowerCase()
}

// Собираем множество известных брендов из базы: factory + все значения поля brand через запятую
export function buildKnownBrandSet(brands: Brand[] | undefined): Set<string> {
  const set = new Set<string>()
  if (!brands) return set
  for (const b of brands) {
    if (b.factory) {
      const n = normalize(b.factory)
      if (n) set.add(n)
    }
    if (b.brand) {
      for (const part of b.brand.split(',')) {
        const n = normalize(part)
        if (n) set.add(n)
      }
    }
  }
  return set
}

export function isKnownBrand(set: Set<string>, value: string): boolean {
  const n = normalize(value)
  if (!n) return false
  return set.has(n)
}
